import e from"react";const r=r=>{const{className:t=""}=r;return e.createElement("hr",{className:`line ${t}`})};export{r as Line};
//# sourceMappingURL=Line.js.map
